import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, DailyYardVehicles } from '@/models/DailyYardVehicle';

// Inital state
const state: DailyYardVehicles = {
  dailyYardVehicles: [],
  yardStatuses: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, DailyYardVehicles> = {
  dailyYardVehicles: (state) => state.dailyYardVehicles,
  yardStatuses: (state) => state.yardStatuses,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, DailyYardVehicles> = {
  setDailyYardVehicles(state, { dailyYardVehicles }) {
    state.dailyYardVehicles = dailyYardVehicles;
  },

  setYardStatuses(state, { yardStatuses }) {
    state.yardStatuses = yardStatuses;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, DailyYardVehicles, Mutations, Getters> = {
  setDailyYardVehicles({ commit }, payload) {
    commit('setDailyYardVehicles', payload);
  },

  setYardStatuses({ commit }, payload) {
    commit('setYardStatuses', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<DailyYardVehicles, Getters, Mutations, Actions>('DailyYardVehicleModule');

export const DailyYardVehicleModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};